interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function SearchBar({ value, onChange, placeholder = 'Pesquisar...' }: SearchBarProps) {
  return (
    <div className="relative">
      <span className="material-symbols-outlined text-on-surface-light absolute top-1/2 left-3 -translate-y-1/2 text-[18px]">
        search
      </span>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="border-line bg-surface text-on-surface placeholder:text-on-surface-light/70 focus:border-primary w-64 rounded-md border py-2.5 pr-5 pl-9 text-sm transition-all focus:shadow-[0_0_0_3px_rgb(from_var(--color-primary)_r_g_b/0.12)] focus:outline-none"
      />
    </div>
  );
}
